import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const InquiryWrap = styled.div`
  width: 600px;
  min-width: 328px;
  margin: 86px auto 204px auto;
  display: block;
  ${customMedia.lessThan('tablet')`
    max-width: 600px;
    width: 100%;
    margin: 0 auto 124px auto;
`}
`
const InquiryTerms = styled.div`
  display: flex;
  font-family: NotoSansMedium, sans-serif;
  font-size: 14px;
  line-height: 26px;
  justify-content: space-around;
  margin: 25px 0 0 0;
  padding-bottom: 5px;

  > p {
    white-space: pre-line;
    color: ${COLOR.black};
    margin: 0;

    > span {
      padding-left: 10px;
      cursor: pointer;
      color: ${COLOR.sub1};
      text-decoration-line: underline;
      ${customMedia.lessThan('tablet')`  
         color: ${COLOR.point1};
       `}
    }
  }

  > img {
    cursor: pointer;
    display: flex;
    width: 26px;
    height: 26px;
    margin-left: 19px;
  }

  ${customMedia.lessThan('tablet')`
    font-size: 12px;
    max-width: 500px;
    width:100%;
    display: flex;
    line-height: 17px;
    justify-content: unset;
    margin: 13.5px 0 56px 0;
    padding:0;
    > img {
      margin: 0;
      width: 20px;
      height: 20px;
      margin-right: 12px
  }
  
 `}

  ${customMedia.lessThan('mobile')`
    margin: 24px 0 37px 0;
    > img {
      margin: 0 12px 0 0;
  }
 `}
`
export { InquiryTerms, InquiryWrap }
